module.exports = __webpack_public_path__ + "static/media/login-inactive.de941b20.svg";